import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { GenericSuccessData, Url, SiteId } from './common';
import { createSiteEndpointPath } from './common';

interface Enrollment extends GenericSuccessData {
  /* eslint-disable camelcase */
  slack_enrollment: {
    scope: string;
    client_id: string;
  };
  /* eslint-enable camelcase */
}

interface Payload {
  /* eslint-disable camelcase */
  code: string;
  redirect_uri: Url;
  /* eslint-enable camelcase */
}

function createEndpointPath(siteId: SiteId): Url {
  return `${createSiteEndpointPath(siteId)}/enroll`;
}

export function get(siteId: SiteId): Promise<AxiosResponse<Enrollment>> {
  const url = createEndpointPath(siteId);
  return axios.get(url);
}

export function set(siteId: SiteId, body: Payload): Promise<AxiosResponse<GenericSuccessData>> {
  const url = createEndpointPath(siteId);
  // success of this request guarantees the success of the next `getConnectionStatus` call
  // these two endpoints refer to the same underlying resource
  return axios.post(url, body);
}
